import { render, staticRenderFns } from "./NewUploadModal.vue?vue&type=template&id=2337b885"
import script from "./NewUploadModal.vue?vue&type=script&lang=js"
export * from "./NewUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports